export const BrowserRoutes = {
  HOME: "/",
  TESTIMONIALS: "testimonials",
  ABOUT: "/about",
  SERVICES: "services",
  OUR_WORK_FLOW: "our-work-flow",
  CONTACT: "contact",
  PRIVACY_POLICY: "/privacy",
  TERMS_OF_SERVICE: "/terms-of-service",
  NOTFOUND: "*",
};
